"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentRequest = void 0;
var PaymentRequest = /** @class */ (function () {
    function PaymentRequest() {
    }
    return PaymentRequest;
}());
exports.PaymentRequest = PaymentRequest;
//# sourceMappingURL=PaymentRequest.js.map